import './style.scss';
import OverflowMenu from './overflowmenu.js';

export default OverflowMenu;